module.exports = __webpack_public_path__ + "img/cov-course.48dadfe7.jpg";